import has from 'lodash/has';
import { getCurrentUtcTime } from '../lib/DateUtils';
import env from '@beam-australia/react-env';
const grantType = 'authorization_code';
const scope = 'com.intuit.quickbooks.accounting';
const corsGateway = `${env('QUICKB_CORS_GATE')}`;

function authenticate(fn, credInfo) {
  const clientId = credInfo['intuit_qb.client_id'];
  const encodedId = credInfo['intuit_qb.auth_secret'];
  const redirectUri = window.location.protocol + '//' + window.location.host + '/intuitAuth';
  let params = [];
  params.push('response_type=code');
  params.push(`client_id=${clientId}`);
  params.push(`scope=${scope}`);
  params.push(`redirect_uri=${redirectUri}`);
  params.push(`state=security_token%3D138r5719ru3e1`);

  window.HandlePopupResult = function (responseJSON, error) {
    if (has(responseJSON, 'code')) {
      let realmid = has(responseJSON, 'realmId') ? responseJSON.realmId : null;
      let oauthCorsUrl = corsGateway + '/oauth2/v1/tokens/bearer';
      fetch(oauthCorsUrl, {
        method: 'POST',
        body: `grant_type=${grantType}&code=${
          responseJSON.code
        }&redirect_uri=${encodeURIComponent(redirectUri)}`,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          Authorization: `Basic ${encodedId}`,
          Accept: 'application/json',
        },
      })
        .then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          }
          throw new Error(response.statusText);
        })
        .then((authInfo) => {
          let authResponse = {
            ...authInfo,
            auth_scheme: 'header',
            scopes: scope,
            realmid: realmid ? realmid : null,
            authorizedAt: getCurrentUtcTime(),
          };

          fn(authResponse);
        })
        .catch(() => {
          console.log('Error in authentication');
        });
    } else {
      console.log('Box authentication error');
    }

    delete window.HandlePopupResult;
  };
  let oauthUrl = 'https://appcenter.intuit.com/connect/oauth2?' + params.join('&');
  window.open(oauthUrl, 'Intuit QuickBooks Oauth', 'top=300,left=250,height=600,width=600');
}

export default {
  authenticate: authenticate,
};
